export const setLatestQuestion = (secId, subSecId, qId) => ({
    type: 'SET_LATEST_QUESTION',
    secId,
    subSecId,
    qId
})

export const setCompleted = (secId, subSecId) => ({
    type: 'SET_COMPLETED',
    secId,
    subSecId
})


// WEBPACK FOOTER //
// ./src/actions/tracker.js